// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={styles.container}>
      <h1 style={styles.code}>404</h1>
      <p style={styles.message}>¡Uy! La página que buscas no existe.</p>
      <Link to="/" style={styles.link}>
        Volver al inicio
      </Link>
    </div>
  );
}

const styles = {
  container: {
    textAlign: 'center',
    padding: '4rem 1rem',
  },
  code: {
    fontSize: '6rem',
    margin: '0',
    color: '#333',
  },
  message: {
    fontSize: '1.5rem',
    margin: '1rem 0 2rem',
    color: '#666',
  },
  link: {
    display: 'inline-block',
    padding: '0.75rem 1.5rem',
    backgroundColor: '#007bff',
    color: '#fff',
    borderRadius: '4px',
    textDecoration: 'none',
  },
};
